<style src="./style.scss">
</style>

<script>
  import { onMount } from "svelte";

  import classNames from "classnames/bind";
  import Icon from "svelte-icon";
  import Eye from "@assets/icons/eye.svg";
  import InputError from "@assets/icons/input-error.svg";
  import InputSuccess from "@assets/icons/input-success.svg";
  import OpenEye from "@assets/icons/open-eye.svg";
  import MaskInput from "svelte-input-mask";

  export let disabled = false;
  export let emptyMessage = "";
  export let placeholder = "";
  export let passwordInput = false;
  export let value = "";
  export let mask = "";
  export let label;
  export let error = false;
  export let success = false;
  export let focused = false;
  export let isLoading = false;
  export let isPhone = false;
  export let use = () => null;
  export let onBlur = () => null;
  export let type = passwordInput ? "password" : "text";
  export let onInput = () => null;

  let isFocused = false;
  let showValue = !passwordInput;

  let inputRef;

  function onFocus() {
    isFocused = true;
  }

  function onBlurComponent() {
    isFocused = false;

    onBlur();
  }

  function toogleShowValue() {
    showValue = !showValue;

    inputRef.type = showValue ? "text" : "password";
    inputRef.focus();
  }

  const className = classNames("text-input");

  const handleChange = ({ detail }) => {
    value = detail.inputState.unmaskedValue;

    if (isPhone) {
      mask = "(00) 0 0000-0000";
    }
  };

  onMount(() => {
    inputRef.type = type;

    if (focused) {
      inputRef.focus();
    }
  });
</script>

<div class="{error ? `${className} field-error` : className}">
  {#if label}
    <label class="{`${className}__label`}">{label}</label>
  {/if}
  <div class="{`${className}__container`}">
    {#if mask}
      <MaskInput
        placeholder="{placeholder}"
        bind:this="{inputRef}"
        class="{`${className}__container__field`}"
        mask="{mask}"
        bind:value
        disabled="{disabled}"
        on:focus="{onFocus}"
        on:blur="{onBlurComponent}"
        on:change="{(event) => handleChange(event)}"
        {...$$props} />
    {:else}
      <input
        bind:this="{inputRef}"
        class="{`${className}__container__field`}"
        bind:value
        placeholder="{placeholder}"
        disabled="{disabled}"
        on:focus="{onFocus}"
        on:blur="{onBlurComponent}"
        on:input="{onInput}"
        use:use
        {...$$props} />
    {/if}

    {#if isLoading}
      <div class="spinner">
        <svg
          class="spinner__circle"
          width="32px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg">
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"></circle>
        </svg>
      </div>
    {:else if success}
      <div class="{`${className}__container__state-icon`}">
        <Icon data="{InputSuccess}" size="24px" stroke="transparent" />
      </div>
    {:else if error && !passwordInput}
      <div class="{`${className}__container__state-icon`}">
        <Icon data="{InputError}" size="24px" stroke="transparent" />
      </div>
    {/if}

    {#if passwordInput}
      <div
        class="{`${className}__container__show-value`}"
        on:click="{toogleShowValue}">
        {#if showValue}
          <Icon
            data="{OpenEye}"
            size="24px"
            fill="{error ? '#FF5630' : isFocused ? '#000AFF' : '#C7C7C7'}"
            stroke="transparent" />
        {:else}
          <Icon
            data="{Eye}"
            size="24px"
            fill="{error ? '#FF5630' : isFocused ? '#000AFF' : '#C7C7C7'}"
            stroke="transparent" />
        {/if}
      </div>
    {/if}
  </div>

  {#if value === "" && emptyMessage}
    <div class="{`${className}__empty-message`}">{emptyMessage}</div>
  {/if}
</div>
